import axios from "@/api/axiosInstance";
import { CompleteAttemptRequest, CompleteAttemptResponse } from "./types";
import type { CoachAttemptDetail } from "../../types/diagnostic";

/**
 * Finish an attempt. The service records the outcome and the stage label at
 * this moment — that recorded stage, not the recomputed envelope, is what
 * every later screen displays.
 *
 * Refused with a 409 unless every applicable question is answered, so the
 * caller saves first.
 */
export const completeAttempt = async (
  attemptId: number,
  payload: CompleteAttemptRequest = {},
): Promise<CoachAttemptDetail> => {
  const response = await axios.post<CompleteAttemptResponse>(
    `/api/private/attempts/${attemptId}/complete`,
    payload,
  );
  return response.data.data;
};
